import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { tomorrow, coy } from 'react-syntax-highlighter/dist/esm/styles/prism'
import type { TextRendererProps } from '../types'

interface CodeRendererProps extends TextRendererProps {
  language?: string
}

export function CodeRenderer({ content, isDarkTheme, wordWrap, showLineNumbers, language }: CodeRendererProps) {
  const syntaxTheme = isDarkTheme ? tomorrow : coy

  const plainTextTheme = {
    'code[class*="language-"]': {
      color: 'var(--text-color)',
      background: 'transparent',
      fontFamily: 'monospace',
      fontSize: '14px',
      lineHeight: '1.6',
    },
    'pre[class*="language-"]': {
      color: 'var(--text-color)',
      background: 'transparent',
      fontFamily: 'monospace',
      fontSize: '14px',
      lineHeight: '1.6',
      margin: 0,
      padding: '16px',
    },
  }

  const useSyntaxHighlighting = language && language !== 'text'
  const style = useSyntaxHighlighting ? syntaxTheme : plainTextTheme

  const codeStyle = {
    margin: 0,
    borderRadius: '8px',
    fontSize: '14px',
    backgroundColor: 'transparent',
    padding: '16px',
    border: 'none',
  }

  return (
    <div className="flex-1 min-h-0 flex flex-col rounded-lg border overflow-hidden" style={{ backgroundColor: 'var(--sidebar-background)', borderColor: 'var(--sidebar-border)' }}>
      <div className="file-preview-content flex-1 overflow-auto">
        <div className="p-4">
          <SyntaxHighlighter
            language={language || 'text'}
            style={style}
            showLineNumbers={showLineNumbers}
            wrapLines={wordWrap}
            wrapLongLines={wordWrap}
            customStyle={codeStyle}
            PreTag="div"
          >
            {content}
          </SyntaxHighlighter>
        </div>
      </div>
    </div>
  )
}
